import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function PrivacyPolicy() {
  return (
    <Container className="py-5">
      <Row>
        <Col>
          <h1 className="mb-4">Politique de confidentialité</h1>
          <p className="lead">Dernière mise à jour : 11 mai 2025</p>

          <section className="mb-5">
            <h2>Introduction</h2>
            <p>
              Chez BoxPlaisir, nous accordons une grande importance à la
              protection de vos données personnelles. Cette politique de
              confidentialité vous informe sur la manière dont nous collectons,
              utilisons et protégeons vos informations lorsque vous utilisez
              notre site web et nos services.
            </p>
            <p>
              All Diffusion SNC, société enregistrée en Belgique sous le numéro
              d'entreprise 1016199219, TVA BE1016199219, dont le siège social
              est situé au rue du Château 13, 5190 Jemeppe-sur-Sambre, est
              responsable du traitement des données collectées sur le site
              BoxPlaisir.be.
            </p>
          </section>

          <section className="mb-5">
            <h2>Données collectées</h2>
            <p>Nous pouvons collecter les types d'informations suivants :</p>
            <ul>
              <li>
                <strong>Informations personnelles</strong> : nom, prénom,
                adresse email, adresse postale, numéro de téléphone, lorsque
                vous créez un compte ou passez une commande.
              </li>
              <li>
                <strong>Informations de paiement</strong> : nous ne stockons pas
                directement vos informations de carte de crédit. Les paiements
                sont traités par des prestataires de services de paiement
                sécurisés.
              </li>
              <li>
                <strong>Informations de connexion</strong> : adresse IP, type de
                navigateur, pages visitées, durée de la visite, et autres
                données de diagnostic.
              </li>
              <li>
                <strong>Informations d'authentification via Google</strong> : si
                vous choisissez de vous connecter via Google, nous recevons
                votre nom, email et photo de profil.
              </li>
              <li>
                <strong>Cookies et technologies similaires</strong> : nous
                utilisons des cookies pour améliorer votre expérience sur notre
                site.
              </li>
            </ul>
          </section>

          <section className="mb-5">
            <h2>Utilisation des données</h2>
            <p>Nous utilisons vos données personnelles pour :</p>
            <ul>
              <li>Gérer votre compte et vous fournir nos services</li>
              <li>Traiter et livrer vos commandes</li>
              <li>
                Vous envoyer des informations sur nos produits et promotions
                (avec votre consentement)
              </li>
              <li>Améliorer notre site web et nos services</li>
              <li>
                Vous authentifier via Google lorsque vous choisissez cette
                option de connexion
              </li>
              <li>Respecter nos obligations légales</li>
            </ul>
          </section>

          <section className="mb-5">
            <h2>Partage des données</h2>
            <p>Nous pouvons partager vos informations avec :</p>
            <ul>
              <li>
                Nos prestataires de services (paiement, livraison, hébergement,
                etc.)
              </li>
              <li>Des tiers lorsque cela est requis par la loi</li>
              <li>
                Google, uniquement dans le cadre de l'authentification OAuth et
                conformément à leurs politiques de confidentialité
              </li>
            </ul>
            <p>Nous ne vendons pas vos données personnelles à des tiers.</p>
          </section>

          <section className="mb-5">
            <h2>Transferts internationaux de données</h2>
            <p>
              Certains de nos prestataires de services peuvent être situés en
              dehors de l'Espace Économique Européen (EEE). Lorsque nous
              transférons vos données personnelles en dehors de l'EEE, nous
              veillons à ce que des garanties appropriées soient en place,
              conformément au RGPD, telles que des clauses contractuelles types
              approuvées par la Commission Européenne.
            </p>
          </section>

          <section className="mb-5">
            <h2>Conservation des données</h2>
            <p>
              Nous conservons vos données personnelles aussi longtemps que
              nécessaire pour vous fournir nos services ou respecter nos
              obligations légales. Les données relatives aux commandes sont
              conservées pendant 10 ans conformément à la législation fiscale et
              comptable belge.
            </p>
          </section>

          <section className="mb-5">
            <h2>Vos droits</h2>
            <p>
              Conformément au Règlement Général sur la Protection des Données
              (RGPD), vous disposez des droits suivants :
            </p>
            <ul>
              <li>Droit d'accès à vos données personnelles</li>
              <li>Droit de rectification de vos données</li>
              <li>Droit à l'effacement de vos données</li>
              <li>Droit à la limitation du traitement</li>
              <li>Droit à la portabilité des données</li>
              <li>Droit d'opposition au traitement</li>
              <li>Droit de retirer votre consentement à tout moment</li>
              <li>
                Droit d'introduire une réclamation auprès de l'Autorité de
                protection des données en Belgique (
                <a
                  href="https://www.autoriteprotectiondonnees.be"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.autoriteprotectiondonnees.be
                </a>
                )
              </li>
            </ul>
            <p>
              Pour exercer ces droits, veuillez nous contacter à l'adresse email
              suivante :{" "}
              <a href="mailto:contact@boxplaisir.be">contact@boxplaisir.be</a>.
            </p>
          </section>

          <section className="mb-5">
            <h2>Sécurité des données</h2>
            <p>
              Nous mettons en œuvre des mesures de sécurité appropriées pour
              protéger vos données contre tout accès, modification, divulgation
              ou destruction non autorisés. Ces mesures incluent le chiffrement
              des données, des contrôles d'accès stricts et des audits de
              sécurité réguliers.
            </p>
          </section>

          <section className="mb-5">
            <h2>Modifications de la politique</h2>
            <p>
              Nous pouvons modifier cette politique de confidentialité à tout
              moment. La version la plus récente sera toujours disponible sur
              notre site web avec la date de dernière mise à jour. En cas de
              modifications substantielles, nous vous en informerons par email
              ou par une notification visible sur notre site.
            </p>
          </section>

          <section className="mb-5">
            <h2>Contact</h2>
            <p>
              Pour toute question concernant cette politique de confidentialité,
              veuillez nous contacter :
            </p>
            <ul>
              <li>
                Par email :{" "}
                <a href="mailto:contact@boxplaisir.be">contact@boxplaisir.be</a>
              </li>
              <li>
                Par courrier : All Diffusion SNC, rue du Château 13, 5190
                Jemeppe-sur-Sambre, Belgique
              </li>
            </ul>
            <p>Responsable du traitement des données : Sébastien Gramtinne</p>
          </section>
        </Col>
      </Row>
    </Container>
  );
}

export default PrivacyPolicy;
